export * from "./product-card-generic";
